<template>
  <div>
    <h1>Email templates</h1>
    <v-btn @click="createEmailTemplate"><v-icon>add</v-icon> Template</v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="emailTemplates"
      class="elevation-1"
      v-if="emailTemplates"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{
                name: 'emailTemplateSales',
                params: { id: props.item.id }
              }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>
            <span v-if="props.item.emailTemplateRevision">{{
              props.item.emailTemplateRevision.subject
            }}</span>
          </td>
          <td>
            <span v-if="props.item.emailTemplateRevision">{{
              props.item.emailTemplateRevision.sendAutomatically
            }}</span>
          </td>
          <td>
            <span v-if="props.item.emailTemplateRevision">{{
              props.item.emailTemplateRevision.schedule
            }}</span>
          </td>
          <td>
            <span
              v-if="
                props.item.emailTemplateRevision &&
                props.item.emailTemplateRevision.published
              "
              >{{
                props.item.emailTemplateRevision.published | formatDateTime
              }}</span
            >
            <span
              v-if="
                props.item.emailTemplateRevision &&
                !props.item.emailTemplateRevision.published
              "
              >Unpublished</span
            >
          </td>
          <td>{{ props.item.archived }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTemplates",
  metaInfo() {
    return {
      title: "Email Templates",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      emailTemplates: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Subject",
          value: "emailTemplateRevision.subject"
        },
        {
          text: "Send automatically",
          value: "emailTemplateRevision.sendAutomatically"
        },
        {
          text: "Schedule",
          value: "emailTemplateRevision.schedule"
        },
        {
          text: "Published",
          value: "emailTemplateRevision.published"
        },
        {
          text: "Archived",
          value: "archived"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    async fetchEmailTemplates() {
      const response = await nbmlaw.get(`/cors/admin/sales/emailTemplates`);
      // console.log(response.data);
      this.emailTemplates = response.data;
    },
    async createEmailTemplate() {
      const response = await nbmlaw.post(
        `/cors/admin/sales/emailTemplates`,
        null
      );
      // console.log(response.data);
      this.$router.push({
        name: "emailTemplateSales",
        params: { id: response.data }
      });
    }
  },
  created() {
    this.fetchEmailTemplates();
  }
};
</script>